

import { useEffect, useRef } from "react";

const TravelWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    const scriptId = "travel-widget-script";

    // Avoid adding the script multiple times
    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "//tp.media/content?trs=17583&shmarker=235892&locale=en&powered_by=false&border_radius=5&plain=true&show_logo=true&color_background=%23FFFFFFff&color_button=%231B9ED9ff&color_text=%23000000&color_input_text=%23000000&color_button_text=%23ffffff&promo_id=4480&campaign_id=10";
    script.charset = "utf-8";
    script.async = true;

    widgetRef.current.appendChild(script);

    return () => {
      // Use optional chaining to prevent errors
      document.getElementById(scriptId)?.remove();
    };
  }, []);

  return <div ref={widgetRef} id="travel-widget-container"></div>;
};

export default TravelWidget;




